export function isAuthenticatedS3URL (s3Url: string | null | undefined): boolean {
  if (!s3Url) return false

  const s3AuthenticatedLinks = [
    'https://agxbucket.s3.sa-east-1.amazonaws.com',
    'https://agxbucket.s3-sa-east-1.amazonaws.com'
  ]

  return s3AuthenticatedLinks.some((link) => s3Url.startsWith(link))
}
